import { EnvironmentProviders, Injectable, Provider } from "@angular/core"
import { TestRoutesProvider } from "./lib/routes/test.routes"

@Injectable({
    providedIn: 'root',
})
export class TestConfigService {
    constructor() {}
}

export const provideTest = (): Array<Provider | EnvironmentProviders> => {
    return [
        { provide: TestRoutesProvider.getToken(), useClass: TestRoutesProvider, multi: true },
    ]
}